import {Dispatch, createContext} from 'react'
import {AnyAction} from '@reduxjs/toolkit'
import {SSLErrorNotificationState} from 'interfaces'
import {noOperation} from 'definitions/constant'
import {sslErrorNotificationInitState} from './reducer'

export const SSLErrorNotificationContext = createContext<
  [SSLErrorNotificationState, Dispatch<AnyAction>]
>([sslErrorNotificationInitState, noOperation])
